'use client';

import { useMemo } from 'react';
import { useFeatureFlags } from '@provider-directory/contexts/FlagContext';
import {
  type AvailabilityWindow,
  resolveAvailabilityWindow,
} from '@provider-directory/functions/availabilityWindow';

export const useAvailabilityWindow = (): AvailabilityWindow => {
  const { featureFlags } = useFeatureFlags();

  return useMemo(
    () => resolveAvailabilityWindow(featureFlags.availabilityWindowDays),
    [featureFlags.availabilityWindowDays],
  );
};
